import * as M from "./messages";
export const PROJECT_NAME = {
  MYDPD: "mydpd",
  SHIPPING: "shipping",
  COLLECTIONS: "collections",
  DELIVERIES: "deliveries",
  PICKUP_RETURNS: "pickup-returns",
  ADDRESS_BOOK: "address-book",
  DATA: "data",
  DEPOT_FINDER: "depot-finder"
};
export const FRIENDLY_PROJECT_NAME = {
  [PROJECT_NAME.MYDPD]: M.MY_DPD,
  [PROJECT_NAME.SHIPPING]: M.SHIPPING,
  [PROJECT_NAME.COLLECTIONS]: M.COLLECTIONS,
  [PROJECT_NAME.DELIVERIES]: M.DELIVERIES,
  [PROJECT_NAME.PICKUP_RETURNS]: M.PICKUP_RETURNS,
  [PROJECT_NAME.ADDRESS_BOOK]: M.ADDRESS_BOOK,
  [PROJECT_NAME.DATA]: M.DATA,
  [PROJECT_NAME.DEPOT_FINDER]: M.LOCATION_MAPS
};